import { CbhFeatureFlag, FEATURE_FLAG_DEFAULT_VALUES, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useShouldEducateNewWorker(workerPastShiftsCount: number | undefined) {
  const educateForFirstNBookings = useCbhFlag(CbhFeatureFlag.EDUCATE_FOR_FIRST_N_BOOKINGS, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.EDUCATE_FOR_FIRST_N_BOOKINGS],
  });

  const shouldEducateNewWorker =
    workerPastShiftsCount !== undefined && workerPastShiftsCount < educateForFirstNBookings;

  return {
    shouldEducateNewWorker,
  };
}
